export default __webpack_public_path__ + "8c37a3cef9ec3fe7885f3471c1073459.png";